import { Link } from "react-router-dom";
import { Palette, Clock, ArrowRight, BookOpen, TrendingUp, GraduationCap, DollarSign, Printer } from "lucide-react";
import { Button } from "../components/ui/button";

const Blog = () => {
  const articles = [
    // NEW: Free Printables (Feb 2025)
    {
      id: "paw-patrol-skye-coloring-pages",
      title: "Skye PAW Patrol Coloring Pages - Free Printables for Kids",
      excerpt: "This pup's gotta fly! Download 7 free Skye coloring pages perfect for preschoolers ages 3-7. Print instantly!",
      category: "Free Printables",
      tier: 0,
      readTime: "5 min read",
      published: true,
      date: "Feb 2025",
      icon: Printer,
      color: "pink",
      featured: true
    },
    // FEATURED: New High-Traffic SEO Articles (Dec 2025)
    {
      id: "how-to-make-coloring-book",
      title: "How to Make a Coloring Book in 2026 [Complete Guide]",
      excerpt: "Everything you need to create your own coloring book - from AI generation to publishing. Create a 50-page book in under 2 hours.",
      category: "Complete Guide",
      tier: 0,
      readTime: "15 min read",
      published: true,
      date: "Dec 2025",
      icon: BookOpen,
      color: "violet",
      featured: true
    },
    {
      id: "coloring-book-to-sell",
      title: "How to Create a Coloring Book to Sell [2026 Profit Guide]",
      excerpt: "Make $500-3,000/month selling coloring books from home. Complete guide to creating, publishing, and profiting.",
      category: "Profit Guide",
      tier: 0,
      readTime: "18 min read",
      published: true,
      date: "Dec 2025",
      icon: DollarSign,
      color: "green",
      featured: true
    },
    {
      id: "best-coloring-page-prompts",
      title: "50 Best Coloring Page Prompts [Free Ideas + Examples]",
      excerpt: "Tested prompts that create beautiful coloring pages every time. Click to copy, paste into ColorWonder, and create!",
      category: "Prompts & Ideas",
      tier: 0,
      readTime: "12 min read",
      published: true,
      date: "Dec 2025",
      icon: BookOpen,
      color: "pink",
      featured: true
    },
    {
      id: "amazon-kdp-publishing",
      title: "How to Publish a Coloring Book on Amazon KDP [2026]",
      excerpt: "Step-by-step guide to publishing your coloring book on Amazon. No upfront costs, worldwide distribution, 60% royalties.",
      category: "Publishing Guide",
      tier: 0,
      readTime: "14 min read",
      published: true,
      date: "Dec 2025",
      icon: TrendingUp,
      color: "amber",
      featured: true
    },
    {
      id: "make-your-own-coloring-book",
      title: "How to Make Your Own Coloring Book [Free Methods]",
      excerpt: "Create personalized coloring books for your kids, classroom, or just for fun. Multiple free methods explained.",
      category: "DIY Guide",
      tier: 0,
      readTime: "10 min read",
      published: true,
      date: "Dec 2025",
      icon: GraduationCap,
      color: "emerald",
      featured: true
    },
    // TIER 1: High-Intent Keywords
    {
      id: "coloring-page-prompts",
      title: "50 Free Coloring Page Prompts for Kids [2026]",
      excerpt: "Discover creative prompts that spark imagination. From magical unicorns to space adventures, these ideas will keep kids entertained for hours.",
      category: "Prompts & Ideas",
      tier: 1,
      readTime: "8 min read",
      published: true,
      date: "Jan 2026",
      icon: BookOpen,
      color: "violet"
    },
    {
      id: "ai-coloring-book-generator-tools",
      title: "AI Coloring Book Generator: 7 Best Tools [Reviewed 2026]",
      excerpt: "We tested the top AI coloring book generators so you don't have to. See which tools create the best printable pages for kids and adults.",
      category: "Tool Reviews",
      tier: 1,
      readTime: "10 min read",
      published: true,
      date: "Jan 2026",
      icon: TrendingUp,
      color: "blue"
    },
    {
      id: "create-coloring-pages-with-ai",
      title: "How to Create Coloring Pages with AI (Free Tutorial)",
      excerpt: "Step-by-step guide to creating professional coloring pages using AI. No design skills needed - just your imagination!",
      category: "Tutorials",
      tier: 1,
      readTime: "12 min read",
      published: true,
      date: "Jan 2026",
      icon: BookOpen,
      color: "green"
    },
    {
      id: "printable-coloring-pages-generator",
      title: "Printable Coloring Pages Generator [Free Tool]",
      excerpt: "Looking for a free tool to create printable coloring pages? Here's your complete guide to generating custom pages in seconds.",
      category: "Tools",
      tier: 1,
      readTime: "6 min read",
      published: true,
      date: "Jan 2026",
      icon: BookOpen,
      color: "pink"
    },
    {
      id: "custom-coloring-pages",
      title: "Custom Coloring Pages: How to Make Them in Seconds",
      excerpt: "Want coloring pages that match exactly what you're looking for? Learn how to create personalized pages for any theme or occasion.",
      category: "Tutorials",
      tier: 1,
      readTime: "7 min read",
      published: true,
      date: "Jan 2026",
      icon: BookOpen,
      color: "orange"
    },
    // TIER 2: Problem-Solving Keywords (Coming Soon)
    {
      id: "dinosaur-coloring-pages",
      title: "Dinosaur Coloring Pages: 100+ Free Printables",
      excerpt: "T-Rex, Triceratops, Velociraptors and more! Download free dinosaur coloring pages or create custom ones with AI.",
      category: "Themed Pages",
      tier: 2,
      readTime: "15 min read",
      published: false,
      date: "Coming Soon",
      icon: BookOpen,
      color: "emerald"
    },
    {
      id: "unicorn-coloring-pages",
      title: "Unicorn Coloring Pages: Free Printables + Generator",
      excerpt: "Magical unicorn coloring pages for kids of all ages. Plus learn how to create your own custom unicorn designs.",
      category: "Themed Pages",
      tier: 2,
      readTime: "12 min read",
      published: false,
      date: "Coming Soon",
      icon: BookOpen,
      color: "pink"
    },
    {
      id: "educational-coloring-pages",
      title: "Educational Coloring Pages for Kindergarten [Free]",
      excerpt: "Make learning fun with educational coloring pages covering letters, numbers, shapes, and more.",
      category: "Education",
      tier: 2,
      readTime: "10 min read",
      published: false,
      date: "Coming Soon",
      icon: GraduationCap,
      color: "blue"
    },
    // TIER 3: Business Keywords (Coming Soon)
    {
      id: "sell-coloring-books-etsy",
      title: "How to Sell Coloring Books on Etsy [Complete Guide 2026]",
      excerpt: "Turn your creativity into income. Learn how to create and sell coloring books on Etsy successfully.",
      category: "Business",
      tier: 3,
      readTime: "20 min read",
      published: false,
      date: "Coming Soon",
      icon: DollarSign,
      color: "green"
    },
    {
      id: "make-coloring-book-to-sell",
      title: "How to Make a Coloring Book to Sell [Step-by-Step]",
      excerpt: "Complete guide to creating professional coloring books you can sell online or in print.",
      category: "Business",
      tier: 3,
      readTime: "18 min read",
      published: false,
      date: "Coming Soon",
      icon: DollarSign,
      color: "emerald"
    },
  ];

  const publishedArticles = articles.filter(a => a.published);
  const comingSoonArticles = articles.filter(a => !a.published);

  const getColorClasses = (color) => {
    const colors = {
      violet: "bg-violet-100 text-violet-700",
      blue: "bg-blue-100 text-blue-700",
      green: "bg-green-100 text-green-700",
      pink: "bg-pink-100 text-pink-700",
      orange: "bg-orange-100 text-orange-700",
      emerald: "bg-emerald-100 text-emerald-700",
    };
    return colors[color] || colors.violet;
  };

  return (
    <div className="min-h-screen bg-hero-gradient">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 glass border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-violet-600 to-indigo-600 flex items-center justify-center">
                <Palette className="w-5 h-5 text-white" />
              </div>
              <span className="font-semibold text-xl text-slate-800" style={{ fontFamily: "'Fredoka', sans-serif" }}>
                ColorWonder
              </span>
            </Link>

            <div className="flex items-center gap-4">
              <Link to="/pricing" className="text-slate-600 hover:text-slate-900 font-medium">
                Pricing
              </Link>
              <Link to="/blog" className="text-violet-600 font-medium">
                Blog
              </Link>
              <Button
                onClick={() => window.location.href = "/signup"}
                className="h-10 px-6 rounded-full bg-gradient-to-r from-violet-600 to-indigo-600 text-white font-semibold hover:shadow-lg"
              >
                Try Free
              </Button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-violet-100 rounded-full text-violet-700 font-medium text-sm mb-6">
            <BookOpen className="w-4 h-4" />
            ColorWonder Blog
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6" style={{ fontFamily: "'Fredoka', sans-serif" }}>
            Coloring Page Ideas, Tips & Tutorials
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Discover creative prompts, learn to use AI for coloring pages, and get inspired to create amazing coloring books for kids and adults.
          </p>
        </div>
      </section>

      {/* Published Articles */}
      <section className="pb-16 px-6 md:px-12 lg:px-24">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl font-bold text-slate-800 mb-8" style={{ fontFamily: "'Fredoka', sans-serif" }}>
            Latest Articles
          </h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {publishedArticles.map((article) => (
              <Link
                key={article.id}
                to={`/blog/${article.id}`}
                className="group bg-white rounded-2xl border border-slate-100 overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                {/* Article Image Placeholder */}
                <div className="aspect-[16/9] bg-gradient-to-br from-violet-100 to-pink-100 flex items-center justify-center relative overflow-hidden">
                  <article.icon className="w-16 h-16 text-violet-300 group-hover:scale-110 transition-transform" />
                  <div className="absolute top-4 left-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getColorClasses(article.color)}`}>
                      {article.category}
                    </span>
                  </div>
                </div>
                
                {/* Content */}
                <div className="p-6">
                  <div className="flex items-center gap-3 text-sm text-slate-500 mb-3">
                    <span>{article.date}</span>
                    <span>•</span>
                    <span className="flex items-center gap-1">
                      <Clock className="w-3 h-3" />
                      {article.readTime}
                    </span>
                  </div>
                  
                  <h3 className="text-lg font-semibold text-slate-800 mb-2 group-hover:text-violet-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  
                  <p className="text-slate-600 text-sm line-clamp-2 mb-4">
                    {article.excerpt}
                  </p>
                  
                  <span className="inline-flex items-center text-violet-600 font-medium text-sm group-hover:gap-2 transition-all">
                    Read Article
                    <ArrowRight className="w-4 h-4 ml-1" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Coming Soon Section */}
      <section className="pb-24 px-6 md:px-12 lg:px-24">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl font-bold text-slate-800 mb-2" style={{ fontFamily: "'Fredoka', sans-serif" }}>
            Coming Soon
          </h2>
          <p className="text-slate-600 mb-8">More helpful guides and resources on the way!</p>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {comingSoonArticles.slice(0, 6).map((article) => (
              <div
                key={article.id}
                className="bg-white/60 rounded-xl border border-slate-100 p-5 opacity-75"
              >
                <div className="flex items-start gap-3">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${getColorClasses(article.color)}`}>
                    <article.icon className="w-5 h-5" />
                  </div>
                  <div>
                    <h3 className="font-medium text-slate-700 text-sm line-clamp-2 mb-1">
                      {article.title}
                    </h3>
                    <span className="text-xs text-slate-400">{article.category}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="pb-24 px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-violet-600 to-indigo-600 rounded-3xl p-8 md:p-12 text-center text-white">
            <h2 className="text-3xl font-bold mb-4" style={{ fontFamily: "'Fredoka', sans-serif" }}>
              Ready to Create Your Own Coloring Pages?
            </h2>
            <p className="text-violet-100 mb-8 max-w-lg mx-auto">
              Turn any idea into beautiful, printable coloring pages in seconds. No design skills needed!
            </p>
            <Button
              onClick={() => window.location.href = "/signup"}
              className="h-14 px-8 rounded-full bg-white text-violet-600 font-semibold text-lg hover:bg-violet-50"
            >
              Try ColorWonder Free
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-slate-100 py-8 px-6">
        <div className="max-w-6xl mx-auto text-center text-slate-500 text-sm">
          <p>© 2026 ColorWonder. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Blog;
